import { Question } from './questions'

/**
 * Returns an error message if the user has not viewed a required concept.
 */
export function getRequireViewConceptError({
  question,
}: {
  question: Question
}) {
  if (
    question.concepts.length === 0 ||
    !question.constraints.requireConceptView
  ) {
    return false
  }

  return !question.concepts[0].viewed
}

/**
 * Returns an error message if the user has not viewed all the required images.
 */
export function getRequireViewImagesError({
  question,
}: {
  question: Question
}) {
  if (
    (question.type !== 'multipleChoice' &&
      question.type !== 'ranking' &&
      question.type !== 'allocation') ||
    !question.constraints.requireImageViews
  ) {
    return false
  }

  const hasViewedAllRequiredImages = question.options.every((option) => {
    if (option.type !== 'image' || !option.constraints.requireView) {
      return true
    }

    return option.image.viewed
  })

  return !hasViewedAllRequiredImages
}
